import { render, staticRenderFns } from "./ManageHelpfulLinks.vue?vue&type=template&id=011ed2de"
import script from "./ManageHelpfulLinks.vue?vue&type=script&lang=ts"
export * from "./ManageHelpfulLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports